import { render, staticRenderFns } from "./court.vue?vue&type=template&id=baf302e0&scoped=true&"
import script from "./court.vue?vue&type=script&lang=js&"
export * from "./court.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf302e0",
  null
  
)

export default component.exports